"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const edit_cosmos_svg_1 = require("components/svg/icons/edit-cosmos.svg");
const translate_1 = require("components/translate");
const useModal_1 = require("hooks/useModal");
const useOnboarding_1 = __importStar(require("hooks/useOnboarding"));
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const query_string_1 = __importDefault(require("query-string"));
const events_1 = __importDefault(require("../../../events"));
const manageCoverPopover_1 = __importDefault(require("../manageCoverPopover"));
const EditAction = ({ t, index, itemId, editionUrl }) => {
    const { isModalOpen: isEditCoverPopoverOpen, handleClose: handleEditCoverPopoverClose } = (0, useModal_1.useModal)({ isOpen: true });
    const { showOnboarding, setOnboardingView } = (0, useOnboarding_1.default)(useOnboarding_1.OnboardingKeys.EditModuleCover);
    const isFirstItem = index === 0;
    const queryString = query_string_1.default.parse(location.search);
    const fromDisplay = queryString['from-display'] || null;
    const showCoverOnboarding = fromDisplay && isFirstItem;
    const handleClosePopover = () => {
        handleEditCoverPopoverClose();
        setOnboardingView();
    };
    const handleClickEditModule = () => {
        handleClosePopover();
        events_1.default.sendModuleEvent({ label: 'Edit' });
        DatahubService_1.default.sendEvent({
            action: constants_1.EVENT_ACTIONS.INTERACT,
            event: (0, helper_1.buildInteractionEventData)({
                category: constants_1.EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.NAME,
                label: constants_1.EVENTS_LABELS.CONTENT.MANAGE_MODULE.EDIT,
                action: constants_1.EVENTS_INTERACTIONS.CLICK
            })
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _align-items-center", children: [showCoverOnboarding && ((0, jsx_runtime_1.jsx)(manageCoverPopover_1.default, { isOpen: isEditCoverPopoverOpen, onClose: handleClosePopover, showOnboarding: showOnboarding })), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: editionUrl, id: `edit-module-${itemId}`, onClick: handleClickEditModule, "data-test": "c-button-edit-module", className: "draggable-link hot-button hot-button--secondary hot-button--sm _mr-2 _text-blue-dark", children: [(0, jsx_runtime_1.jsx)(edit_cosmos_svg_1.ReactComponent, {}), t('general.edit')] })] }));
};
exports.default = (0, translate_1.translate)()(EditAction);
